export default __webpack_public_path__ + "f55cf115a78d4c4bb4ca4211a1ea40e9.png";